import banner_img from "../../images/application/BannerImage.png";
import banner from "../../images/banner/banner.jpg";
import bannerWave from "../../images/banner/wave.svg";
import main_img from "../../images/banner/summary_img1.PNG";
import video from "../../images/banner/vedio.svg";
import aboutImg from "../../images/banner/aboutImg.png";
import ip_img from "../../images/banner/ip_img1.png"
import lab_img from "../../images/banner/lab_img1.png"
import op_img from "../../images/banner/op_img1.png"
import pharmacy_img from "../../images/banner/pharmacy_img1.png"
import profile from "../../images/Testimonial/profile.svg"
import partner_img from "../../images/channelPartners/partner_img.jpg"



import BillLogo1 from "../../../assets/images/partners/107_BillLogo.png";
import BillLogo2 from "../../../assets/images/partners/109_BillLogo.png";
import AKS from "../../../assets/images/partners/AKS.jpeg";
import ASHOKA_DIAGNOSTICS from "../../../assets/images/partners/ASHOKA DIAGNOSTICS.PNG";
import card_logo from "../../../assets/images/partners/card_logo.png";
import DOCTOS_DIAGNOSTIC_CENTER from "../../../assets/images/partners/DOCTO'S DIAGNOSTIC CENTER.PNG";
import Haritha_Hospital from "../../../assets/images/partners/HarithaHospital.jpg";
import jagannadh_Hospitals from "../../../assets/images/partners/jagannadh hospitals.PNG";
import Jyothi_Hospitals from "../../../assets/images/partners/Jyothi hospitals.jpeg";
import kosuru_Hospital from "../../../assets/images/partners/kosuru hospital.jpeg";
import KUSUMA_HOSPITALS from "../../../assets/images/partners/KUSUMA HOSPITALS.PNG";
import LS_NURSING_HOME_DIAGNOSTICS from "../../../assets/images/partners/LS NURSING HOME & DIAGNOSTICS.PNG";
import MARUTHI_LABORATORY from "../../../assets/images/partners/MARUTHI LABORATORY.PNG";
import matrix_Hospital from "../../../assets/images/partners/matrix hospital.jpeg";
import QUALITY_DIAGNOSTICS from "../../../assets/images/partners/QUALITY DIAGNOSTICS.PNG";
import SAMYUKTHA_DIAGNOSTICS from "../../../assets/images/partners/SAMYUKTHA DIAGNOSTICS.PNG";
import SJ_HEALTH_CARE_AND_DIAGNOSTICS from "../../../assets/images/partners/SJ HEALTH CARE AND DIAGNOSTICS.PNG";
import SONAKSHI_CLINICALLAB from "../../../assets/images/partners/SONAKSHI CLINICAL LAB.PNG";
import SR_HOSPITALS from "../../../assets/images/partners/SR HOSPITALS.png";
import SRI_CLINICAL_LABORATORY from "../../../assets/images/partners/SRI CLINICAL LABORATORY.PNG";
import SRI_HAMSINI_LAB from "../../../assets/images/partners/SRI HAMSINI LAB.PNG";
import SRI_KARTHIKEYA_DIAGNOSTIC_CENTER from "../../../assets/images/partners/SRI KARTHIKEYA DIAGNOSTIC CENTER.PNG";
import SRI_NOOKAMBIKA_MEDICAL_CENTER from "../../../assets/images/partners/SRI NOOKAMBIKA MEDICAL CENTER.PNG";
import SRI_SAI_DIAGNOSTICS from "../../../assets/images/partners/SRI SAI DIAGNOSTICS.PNG";
import SRI_SAI_RAM_MEDICAL_DIAGNOSTICS from "../../../assets/images/partners/SRI SAI RAM MEDICAL DIAGNOSTICS.PNG";
import SRI_VENKATA_RAMANA_DIGITAL_XRAY_AND_DIAGNOSTIC_CENTER from "../../../assets/images/partners/SRI VENKATA  RAMANA DIGITAL X-RAY AND DIAGNOSTIC CENTER.PNG";
import Sri_care_Hospital from "../../../assets/images/partners/Sricare Hostl.png";
import Sujatha_Hospital_Logo from "../../../assets/images/partners/sujatha hospital logo.PNG";
import TRINITYLOGO1 from "../../../assets/images/partners/TRINITYLOGO1.jpg";
import UPAS_INFORMATION_CENTER from "../../../assets/images/partners/UPAS INFORMATION CENTER.PNG";
import vasanthi_Hospital from "../../../assets/images/partners/vasanthi hsopital.jpg";
import VIJAYA_CLINIC_DIAGNOSTICS from "../../../assets/images/partners/VIJAYA CLINIC DIAGNOSTICS.PNG";
import VISAKA_LABORATORY from "../../../assets/images/partners/VISAKA LABORATORY.PNG";


import review1 from "../../../assets/images/Testimonial/review1.jpg";
import review2 from "../../../assets/images/Testimonial/review2.jpg";
import review3 from "../../../assets/images/Testimonial/review3.jpg";
import test from "../../../assets/images/Testimonial/test1.svg";
import user_icon from "../../../assets/images/Testimonial/user_icon.svg"
import soc1 from "../../../assets/images/footer/soc1.svg";
import soc2 from "../../../assets/images/footer/soc2.svg";
import soc3 from "../../../assets/images/footer/soc3.svg";
import soc4 from "../../../assets/images/footer/soc4.svg";
import googlestore from "../../images/footer/G-Play.svg";
import applestore from "../../images/footer/AppStore.svg";
import dark_logo from "../../images/logos/dark-logo.svg";
import light_logo from "../../images/logos/light-logo.svg";
import hmslogo from "../../images/logos/hmslogo.png";

import hms1 from "../../images/hms/hms1.png";
import hms2 from "../../images/hms/hms2.png";
import hms3 from "../../images/hms/hms3.png";
import hms4 from "../../images/hms/hmss4.jpg";
import lab1 from "../../images/labs/lab1.png";
import lab2 from "../../images/labs/lab2.png";
import lab3 from "../../images/labs/lab3.png";

import menu_icon from "../../images/menu-icon/menu.svg";
import close_icon from "../../images/menu-icon/close.svg";
import right from "../../images/menu-icon/right.svg";
import call from "../../images/contact/call.svg";
import email from "../../images/contact/email.svg";
import location from "../../images/contact/location.svg";
import icon1 from "../../images/icons/icon1.svg";
import icon2 from "../../images/icons/icon2.svg";
import icon3 from "../../images/icons/icon3.svg";
import icon4 from "../../images/icons/icon4.svg";
import icon5 from "../../images/icons/icon5.svg";
import icon6 from "../../images/icons/icon6.svg";
import icon7 from "../../images/icons/icon7.svg";

import counter1 from "../../images/counter/hospital.gif";
import counter2 from "../../images/counter/bill.gif";
import counter3 from "../../images/counter/document.gif";
import counter4 from "../../images/counter/count_icon1.svg";
import hospital from "../../images/counter/Hospital.svg";
import lab from "../../images/counter/lab.svg";
import patient from "../../images/counter/patient.svg";
import bill from "../../images/counter/bills.svg";
import customer from "../../images/counter/customer.svg";


import check from "../../images/icons/check.svg";

//application images

import opdcard from "../../images/application/opdcard.png";
import error from "../../images/errorpage/error.jpg";
import about1 from "../../images/application/about1.png";
import about2 from "../../images/application/about2.png";
import about3 from "../../images/application/about3.png";
import about4 from "../../images/application/about4.png";

import lims1 from "../../images/lims/lims1.png";
import lims2 from "../../images/lims/lims2.png";
import lims3 from "../../images/lims/lims3.png";
import cost from "../../images/lims/cost.jpg"
import innerhms1 from "../../images/innerhms/innerhms1.png";
import innerhms2 from "../../images/innerhms/innerhms2.png";
import innerhms3 from "../../images/innerhms/innerhms3.png";
import innerhms4 from "../../images/innerhms/innerhms4.png";
import innerhms5 from "../../images/innerhms/innerhms5.png";

import registration from "../../images/hms/registration.jpg";
import interaction from "../../images/hms/interaction.jpg";
import reporting from "../../images/hms/reporting.jpg"

const Images = {
  ErrorPage: {
    error: error,
  },
  logos: {
    dark_logo: hmslogo,
    light_logo: hmslogo,
  },
  menu: {
    menu_icon: menu_icon,
    close_icon: close_icon,
    right: right,
  },
  lims:{
    lims1:lims1,
    lims2:lims2,
    lims3:lims3,
    cost:cost
  },
  innerhms:{
    innerhms1:innerhms1,
    innerhms2:innerhms2,
    innerhms3:innerhms3,
    innerhms4:innerhms4,
    innerhms5:innerhms5,

  },
  contact: {
    call: call,
    email: email,
    location: location,
  },
  channelPartner:{
    partner_img:partner_img
  },
  home: {
    bannerImage: banner_img,
    banner: banner,
    main_img:main_img,
    ip_img:ip_img,
    op_img:op_img,
    lab_img:lab_img,
    pharmacy_img:pharmacy_img,
    bannerWave: bannerWave,
    video: video,
  },
  partner: {
    BillLogo1:BillLogo1,
    BillLogo2:BillLogo2,
    AKS:AKS,
    ASHOKA_DIAGNOSTICS:ASHOKA_DIAGNOSTICS,
    card_logo:card_logo,
    DOCTOS_DIAGNOSTIC_CENTER:DOCTOS_DIAGNOSTIC_CENTER,
    Haritha_Hospital:Haritha_Hospital,
    jagannadh_Hospitals:jagannadh_Hospitals,
    Jyothi_Hospitals:Jyothi_Hospitals,
    kosuru_Hospital:kosuru_Hospital,
    KUSUMA_HOSPITALS:KUSUMA_HOSPITALS,
    LS_NURSING_HOME_DIAGNOSTICS:LS_NURSING_HOME_DIAGNOSTICS,
    MARUTHI_LABORATORY:MARUTHI_LABORATORY,
    matrix_Hospital:matrix_Hospital,
    QUALITY_DIAGNOSTICS:QUALITY_DIAGNOSTICS,
    SAMYUKTHA_DIAGNOSTICS:SAMYUKTHA_DIAGNOSTICS,
    SJ_HEALTH_CARE_AND_DIAGNOSTICS:SJ_HEALTH_CARE_AND_DIAGNOSTICS,
    SONAKSHI_CLINICALLAB:SONAKSHI_CLINICALLAB,
    SR_HOSPITALS:SR_HOSPITALS,
    SRI_CLINICAL_LABORATORY:SRI_CLINICAL_LABORATORY,
    SRI_HAMSINI_LAB:SRI_HAMSINI_LAB,
    SRI_KARTHIKEYA_DIAGNOSTIC_CENTER:SRI_KARTHIKEYA_DIAGNOSTIC_CENTER,
    SRI_NOOKAMBIKA_MEDICAL_CENTER:SRI_NOOKAMBIKA_MEDICAL_CENTER,
    SRI_SAI_DIAGNOSTICS:SRI_SAI_DIAGNOSTICS,
    SRI_SAI_RAM_MEDICAL_DIAGNOSTICS:SRI_SAI_RAM_MEDICAL_DIAGNOSTICS,
    SRI_VENKATA_RAMANA_DIGITAL_XRAY_AND_DIAGNOSTIC_CENTER:SRI_VENKATA_RAMANA_DIGITAL_XRAY_AND_DIAGNOSTIC_CENTER,
    Sri_care_Hospital:Sri_care_Hospital,
    Sujatha_Hospital_Logo:Sujatha_Hospital_Logo,
    TRINITYLOGO1:TRINITYLOGO1,
    UPAS_INFORMATION_CENTER:UPAS_INFORMATION_CENTER,
    vasanthi_Hospital:vasanthi_Hospital,
    VIJAYA_CLINIC_DIAGNOSTICS:VIJAYA_CLINIC_DIAGNOSTICS,
    VISAKA_LABORATORY:VISAKA_LABORATORY
    // partnerImage_1: img1,
    // partnerImage_2: img2,
    // partnerImage_3: img3,
    // partnerImage_4: img4,
    // partnerImage_5: img5,
    // partnerImage_6: img6,
    // partnerImage_7: img7,
    // partnerImage_8: img8,
    // partnerImage_9: img9,
    // partnerImage_10: img10,
    // partnerImage_11: img11,
    // partnerImage_12: img12,
  },
  testimonial: {
    review1: review1,
    review2: review2,
    review3: review3,
    test: test,
    profile:profile,
    kosuru_Hospital:kosuru_Hospital,
    user_icon :user_icon 
  },
  footer: {
    soc1: soc1,
    soc2: soc2,
    soc3: soc3,
    soc4: soc4,
    googlestore: googlestore,
    applestore: applestore,
  },
  cardSection: {
    icon1: icon1,
    icon2: icon2,
    icon3: icon3,
    icon4: icon4,
    icon5: icon5,
    icon6: icon6,
    icon7: icon7,
  },
  hms: {
    hms1: hms1,
    hms2: hms2,
    hms3: hms3,
    hms4: hms4,
    registration:registration,
    interaction:interaction,
    reporting:reporting,
    
  },
  labs: {
    lab1: lab1,
    lab2: lab2,
    lab3: lab3,
  },
  counter: {
    counter1: counter1,
    counter2: counter2,
    counter3: counter3,
    counter4: counter4,
    hospital:hospital,
    lab:lab,
    patient:patient,
    bill:bill,
    customer:customer

  },
  icons: {
    check: check,
  },
  application: {
    opdcard: opdcard,
    about1:about1,
    about2:about2,
    about3:about3,
    about4:about4
  },
  about:{
    aboutImg:aboutImg
  }
};
export default Images;
